type Props = {
  size?: number;
  className?: string;
};

export function LogoMark({ size = 36, className = '' }: Props) {
  const fontSize = Math.round(size * 0.5);
  return (
    <div
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        background: 'linear-gradient(135deg, var(--accent), var(--indigo))',
        color: 'var(--bg-primary)',
        fontWeight: 900,
        fontSize,
        lineHeight: 1,
        fontFamily: 'var(--font-sans), system-ui, sans-serif',
      }}
      aria-hidden="true"
    >
      A
    </div>
  );
}
